
import { FiltriReintegri } from '@/store';
import { FinderBase } from './FinderBase';
import dayjs from 'dayjs';

export class FinderReintegri extends FinderBase
{
    public idDistintaDPCStatica?: string;
    public filtroDataInserimentoDa?: Date;
    public filtroDataInserimentoA?: Date;

    public constructor(idFornitore:string, pagina?: number) {
        super();

        this.idFornitore = idFornitore;
        if(pagina) {
            this.numeroPagina = pagina;
        }
    }

    public ApplicaFiltriReintegri(filtri: FiltriReintegri) {
        //TODO usare RangeDesriptor
        this.idDistintaDPCStatica = filtri.idDistintaStatica;
        let dataDa = dayjs(filtri.dataInserimentoDa, { utc: true });
        if(dataDa.isValid()) {
            this.filtroDataInserimentoDa = dataDa.toDate();
        }

        let dataA = dayjs(filtri.dataInserimentoA, { utc: true });
        if(dataA.isValid()) {
            this.filtroDataInserimentoA = dataA.toDate();
        }
    }
}